import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Sidebar from './Sidebar'
import MainMenu from './MainMenu'
import BuildDetail from './sections/BuildDetail'
import Installation from './sections/Installation'
import Support from './sections/Support'
import DarkTheme from './sections/DarkTheme'
import ChangeLog from './sections/ChangeLog'
import BrowserCompatibility from './sections/BrowserCompatibility'
import * as ComponentActions from '../actions'
import commonUI from '../../js/commonUI'
import { initPlugins } from '../lib/utils'

class GettingStarted extends Component {

  constructor({ components }) {
    super()
  }

  handleIncludeClick(component, index) {
    this.props.actions.toggleComponent(component, index)
  }

  componentDidMount() {
    setTimeout(() => {
      commonUI.initializeNavigation();
      initPlugins();
    }, 0)
  }

  getFilteredContent(components) {
//    return components.GettingStarted
    return components["Getting Started"]
  }

  renderMainMenu(components, staticVersion) {
    return (<MainMenu components={components} selected="GettingStarted" staticVersion={staticVersion} />)
  }

  renderSidebar(filteredContent, staticVersion) {
    return (<Sidebar sections={filteredContent} selected="GettingStarted" staticVersion={staticVersion}/>)
  }

  render() {
    const { components } = this.props
    const staticVersion = this.props.config.staticVersion;
    const filteredContent = this.getFilteredContent(components);

    return (
      <div>
        {this.renderMainMenu(components, staticVersion)}
        {this.renderSidebar(filteredContent, staticVersion)}
        <div id="main" className="content">
          <div className="grid">
            <div className="grid__col-sm-12 main">
              <Installation
                staticVersion={staticVersion}/>
              <DarkTheme/>
              { staticVersion === false ? (
                <Support/>
              ) : ('')}
              <ChangeLog
                staticVersion={staticVersion}/>
              { staticVersion === false ? (
                <BuildDetail
                  components={components}
                  onIncludeClick={(component, index) => this.handleIncludeClick(component, index)}/>
              ) : ('')}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(ComponentActions, dispatch)
  }
}

function mapStateToProps(state) {
  return { components: state.components, config: state.config }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GettingStarted)



// WEBPACK FOOTER //
// ./styleguide/components/GettingStarted.js